import { render, staticRenderFns } from "./menu_user.vue?vue&type=template&id=97275694&scoped=true&"
import script from "./menu_user.vue?vue&type=script&lang=js&"
export * from "./menu_user.vue?vue&type=script&lang=js&"
import style0 from "./menu_user.vue?vue&type=style&index=0&id=97275694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97275694",
  null
  
)

export default component.exports